import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { FollowingMemberService } from '@app/shared/services/followingMember/followingMember.service';
import { IsLoggedGuard } from '@app/shared/guards';

@Component({
  selector: 'vc-follow-button',
  templateUrl: './follow-button.component.html',
  styleUrls: ['./follow-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FollowButtonComponent {
  @Input()
  userToFollow: string;
  @Input()
  isFollow = false;
  @Input()
  isProductPage = false;
  @Input()
  stopPropagation = true;
  @Output() isBeingFollowed = new EventEmitter<boolean>(); // onFollow

  constructor(private followMemberService: FollowingMemberService, private loggedGuard: IsLoggedGuard) {}

  toggleSubscribe(event) {
    event.preventDefault();
    if (this.stopPropagation) {
      event.stopPropagation();
    }
    if (this.loggedGuard.isLoggedIn()) {
      if (this.isFollow) {
        this.followMemberService.unFollowMember(this.userToFollow).subscribe(
          () => {},
          () => {
            // silent catch nothing to do
          }
        );
      } else {
        this.followMemberService.followMember(this.userToFollow).subscribe(
          res => {},
          () => {
            // silent catch nothing to do
          }
        );
      }
    }
  }
}
